"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutContext = void 0;
var _react = require("react");
var LayoutContext = exports.LayoutContext = /*#__PURE__*/(0, _react.createContext)({
  mobile: false,
  drawer: {
    open: false,
    width: 0
  },
  user: {
    blocked: false
  },
  openDrawer: function openDrawer(open, write) {},
  toggleDrawer: function toggleDrawer() {},
  closeDrawer: function closeDrawer() {},
  blockUser: function blockUser() {}
});